import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import HeaderRow from './HeaderRow';
import P from '../../global/typography/P';
import MobileResult from './MobileResult';
import ResultsRow from './ResultsRow';

const DesktopResultsRow = styled(ResultsRow)`
  display: flex;
  @media ${p => p.theme.media.largePhone} {
    display: none;
  }
`;

const EmptyMessage = styled(P)`
  text-align: center;
`;

const MobileResultsRow = styled(MobileResult)`
  display: none;
  @media ${p => p.theme.media.largePhone} {
    display: block;
  }
`;

const ResponsiveHeader = styled(HeaderRow)`
  display: flex;
  @media ${p => p.theme.media.largePhone} {
    display: none;
  }
`;

const Results = ({ results, showTraining = false }) => {
  if (results.length === 0) {
    return <EmptyMessage>No Results</EmptyMessage>;
  }

  return (
    <div>
      <ResponsiveHeader showTraining={showTraining} />
      {results.map((r, i) => (
        <div key={i}>
          <MobileResultsRow
            showTraining={showTraining}
            {...r}
          />
          <DesktopResultsRow
            showTraining={showTraining}
            {...r}
          />
        </div>
      ))}
    </div>
  );
};

Results.propTypes = {
  results: PropTypes.array,
  showTraining: PropTypes.bool
};

export default Results;
